import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { colors } from '../../../../../../constants/colors';
import { biggerThan } from '../../../../../../core/util/styledComponents';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import Header from './components/Header';
import CopayFaqExpansionPanel from './components/CopayFaqExpansionPanel';
import CarrierContactInfo from './components/CarrierContactInfo';
import Feedback from './components/Feedback';
import Footnote from './components/Footnote';
import { COPAY_COINSURANCE_DETAILS_MODAL } from '../../../../../../constants/modalIds';
import useModal from '../../../../../../hooks/useModal';
import useSelectUserProfile from '../../../../hooks/useSelectUserProfile';
import useSelectInsuranceProfile from '../../../../hooks/useSelectInsuranceProfile';
import SwimLanes from '../../../SwimLanes';
import { CategoryIds } from '../../../SwimLanes/util/tileEnums';

const SmoothDialog = styled(Dialog).withConfig({ componentId: 'sc-1j20sfu-0' })`
  -webkit-font-smoothing: antialiased;
  max-width: 500px;
  & .dialog-root {
    background-color: ${colors.theWhiteAlbum};
  }

  ${biggerThan.sm`
      height: 570px;
      margin: 100px auto;
  `}
`;

const ContentContainer = styled.div.withConfig({ componentId: 'sc-1j20sfu-1' })`
  background-color: ${colors.whiteGrey};
`;

const Title = styled.div.withConfig({ componentId: 'sc-1j20sfu-2' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumLarge};
  letter-spacing: 0.36px;
  color: ${colors.squid};
  margin: 30px 0 20px 30px;
`;

type Props = {
  open: boolean;
  providerType?: string;
  userProfileId: string;
};

const CopayCoinsuranceDetailsModal = (props: Props) => {
  const { open, userProfileId, providerType } = props;
  const userProfile = useSelectUserProfile(userProfileId);
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);
  const { closeModal } = useModal(COPAY_COINSURANCE_DETAILS_MODAL);

  return (
    <SmoothDialog
      fullScreen
      fullWidth
      maxWidth={false}
      onClose={closeModal}
      open={open}
      PaperProps={{ classes: { root: 'dialog-root' } }}
      scroll="body"
      transitionDuration={{ exit: 0 }}
    >
      <Header closeModal={closeModal} providerType={providerType} />

      <ContentContainer>
        <Title>Cost estimate</Title>

        <SwimLanes
          categoryIds={[CategoryIds.COPAY_COINSURANCE_DETAILS_MODAL]}
          userProfile={userProfile}
        />

        <Title>Common questions</Title>

        <CopayFaqExpansionPanel />

        <Title>Need help?</Title>

        <CarrierContactInfo insuranceProfile={insuranceProfile} />

        <Title>Send feedback</Title>

        <Feedback />

        <Footnote />
      </ContentContainer>
    </SmoothDialog>
  );
};

export default CopayCoinsuranceDetailsModal;
